<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar dense dark tile flat class="title text-center text-md-right">
            What church resources are you requesting?
        </v-toolbar>
      </v-col>
      <v-col cols="6" md="3" v-if="event.type != 'ministry-offSite'">
        <v-checkbox color="secondary" dense v-model="event.resources" label="Worship Center" value="worshipCenter"></v-checkbox>
      </v-col>
      <v-col cols="6" md="3" v-if="event.type != 'ministry-offSite'">
        <v-checkbox color="secondary" dense v-model="event.resources" label="Lobby" value="lobby"></v-checkbox>
      </v-col>
      <v-col cols="6" md="3" v-if="event.type != 'ministry-offSite'">
        <v-checkbox color="secondary" dense v-model="event.resources" label="Kitchen" value="kitchen"></v-checkbox>
      </v-col>
      <v-col cols="6" md="3" v-if="event.type != 'ministry-offSite'">
        <v-checkbox color="secondary" dense v-model="event.resources" label="Connection Point" value="connectionPoint"></v-checkbox>
      </v-col>
      <v-col cols="6" md="3" v-if="event.type != 'ministry-offSite'">
        <v-checkbox color="secondary" dense v-model="event.resources" label="Conference Room" value="conferenceRoom"></v-checkbox>
      </v-col>
      <v-col cols="6" md="3" v-if="event.type == 'ministry-onSite' || event.type == 'ministry-offSite'">
        <v-checkbox color="secondary" dense v-model="event.resources" label="Church Van" value="van"></v-checkbox>
      </v-col>
      <v-col cols="6" md="3" v-if="event.type != 'ministry-offSite'">
        <v-checkbox color="secondary" dense v-model="event.resources" label="Classrooms" value="classrooms"></v-checkbox>
      </v-col>
      <v-col cols="12" v-if="event.resources.includes('kitchen')">
        <v-radio-group column v-model="event.usingKitchen" label="Will you plan on using the oven or stove in the kitchen?">
          <v-radio label="Yes" :value=true color="accent"></v-radio>
          <v-radio label="No" :value=false color="accent"></v-radio>
        </v-radio-group>
        <v-text-field 
          v-if="event.usingKitchen"
          outlined color="secondary" 
          v-model="event.approvedKitchenPerson" 
          label="Because of the nature of our industrial-grade appliances a church-approved person must oversee this." 
          hint="Please enter the name of your church-approved individual for use of these appliances" 
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" v-if="event.resources.includes('worshipCenter')">
        <v-radio-group column v-model="event.usingAV" label="Will you plan on using the AV system?">
          <v-radio label="Yes" :value=true color="accent"></v-radio>
          <v-radio label="No" :value=false color="accent"></v-radio>
        </v-radio-group>
        <v-text-field 
          v-if="event.usingAV"
          outlined color="secondary" 
          v-model="event.approvedSoundPerson" 
          label="Use of the church AV requires a church-approved individual." 
          hint="Please enter the name of your church-approved individual." 
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" v-if="event.resources.includes('classrooms')">
        <v-text-field outlined color="secondary" v-model="event.classrooms" label="Please list desired classrooms:"></v-text-field>
      </v-col>
      <v-col cols="12" v-if="event.resources.includes('van')">
        <v-text-field outlined color="secondary" v-model="event.driver" label="Who is/are your church-approved driver(s)?"></v-text-field>
      </v-col>
      <v-col cols="12" v-if="event.resources.length > 0">
        <v-textarea outlined color="secondary" v-model="event.resourceNotes" label="Please list items you will need for each area:" 
          hint="Please list items you will need for each area (e.g. DVD player, 20 chairs, 4 round tables, etc):"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    eventInfo : Object
  },
  data(){
    return {
      event         : this.eventInfo,
    }
  }
}
</script>

<style lang="css" scoped>
</style>
